const resize = ({ w, h, minW, maxW, minH, maxH }) => {
	const ratio = Math.min(maxW / w, maxH / h);
	return { w: w * ratio, h: h * ratio };
};
export default resize;
